import {
  DialogAdditionalParamKey,
  DialogKey,
} from '@sorare/core/src/components/navigation/WithDialogs';
import { useCloseDialog } from '@sorare/core/src/hooks/navigation/useCloseDialog';
import { useDialogParam } from '@sorare/core/src/hooks/navigation/useDialogParam';

import { DecisivePlayerPickerDialog } from '#src/components/missions/picker/DecisivePlayerPickerDialog/index.tsx';

export const DecisivePlayerPickerDialogFromParams = () => {
  const taskId = useDialogParam(DialogKey.decisivePlayerPicker);
  const slotIndexParam = useDialogParam(DialogAdditionalParamKey.slotIndex);
  const closeDialog = useCloseDialog();

  if (!taskId) {
    return null;
  }

  const slotIndex = slotIndexParam ? Number(slotIndexParam) : 0;
  const close = () =>
    closeDialog(DialogKey.decisivePlayerPicker, [
      DialogAdditionalParamKey.slotIndex,
    ]);

  return (
    <DecisivePlayerPickerDialog
      taskId={taskId}
      defaultSelectedSlotIndex={Number.isNaN(slotIndex) ? 0 : slotIndex}
      onClose={close}
      onSuccess={close}
    />
  );
};
